<div class="width-1100">

  <mat-card>

    <mat-toolbar class="toolbar-top">

      <div class='title' style='padding: 10px;'>
        CAEX - Pagamento
      </div>

      <button mat-button (click)='goBack()'>
        <mat-icon>arrow_back</mat-icon>
      </button>

    </mat-toolbar>

  </mat-card>

  <div class='div-progress'>
    <mat-progress-bar [ngClass]="{hidden: !spinner}" color='warn' mode="indeterminate">
    </mat-progress-bar>
  </div>

  <mat-card>

    <div class='order-line'>
      <div class='order-label'>
        Evento:
      </div>
      <div class='order-field'>
        {{currentOrderd.product_name}}
      </div>
    </div>

    <div class='order-line'>
      <div class='order-label'>
        Nome:
      </div>
      <div class='order-field'>
        {{currentOrderd.member_name}}
      </div>
    </div>

    <div class='order-line'>
      <div class='order-label'>
        Email:
      </div>
      <div class='order-field'>
        {{currentOrderd.member_email}}
      </div>
    </div>

    <div class='order-line'>
      <div class='order-label'>
        Doc:
      </div>
      <div class='order-field'>
        {{currentOrderd.member_cpf}}
      </div>
    </div>

    <div class='order-line'>
      <div class='order-label'>
        Categoria:
      </div>
      <div class='order-field'>
        {{currentOrderd.category_name}}
      </div>
    </div>

    <hr>

    <!--
    <div class='order-line' *ngIf="!currentOrderd.payAsOverdue">
      <div class='order-label'>
        Inadimplente
      </div>
      <div class='order-field'>
        Sim
      </div>
    </div>
 

    <div class='order-line' *ngIf="!currentOrderd.payAsOverdue">
      <div class='order-label'>
        Débito R$:
      </div>
      <div class='order-field-value'>
        {{currentOrderd.member_debit | currency:'BRL':'':'1.2-2'}}
      </div>
    </div>
    -->

    <div class='order-line'>
      <div class='order-label'>
        Inscrição R$:
      </div>
      <div class='order-field-value'>
        {{currentOrderd.value | currency:'BRL':'':'1.2-2'}}
      </div>
    </div>

    <div class='order-line'>
      <div class='order-label'>
        Total R$:
      </div>
      <div class='order-field-value'>
        <b>{{currentOrderd.total | currency:'BRL':'':'1.2-2'}}</b>
      </div>
    </div>

    <div class='order-line'>
      <div class='order-label'>
        Total USD$:
      </div>
      <div class='order-field-value'>
        {{ usd_value | currency:'BRL':'':'1.2-2'}}
      </div>
    </div>

  </mat-card>

  <mat-card>
    <form [formGroup]="orderForm">

      <div style="display:flex; flex-direction: row; justify-content: space-between;">

        <div style="height: 40px;">
          <mat-form-field class="tid-width">
            <input matInput type="text" [errorStateMatcher]="matcher" [formControl]="orderForm.controls.tid"
              placeholder="Comprovante pagamento" autocomplete="off">
            <mat-error *ngIf="orderForm.controls.tid.hasError('required')">
              O número do comprovante é obrigatório
            </mat-error>
          </mat-form-field>

          <button mat-raised-button (click)='saveOrder()' [disabled]="orderForm.invalid"
            style='width:100px; font-size: 14px; color:green; margin:0px 0px 0 0;'>
            Registrar
          </button>

        </div>

      </div>

    </form>
  </mat-card>

</div>